import { Injectable } from '@angular/core';
import {
  AbstractContentUndoService2D,
  UndoState2D,
} from '../../shared/state/abstract-content-state-2d-undo.service';
import { VideoContentState } from './video-content-state';
import { VideoContentStore } from './video-content-store';

@Injectable()
export class VideoContentStateUndoService extends AbstractContentUndoService2D<
  VideoContentState,
  UndoState2D
> {
  constructor(rootStore: VideoContentStore) {
    super(rootStore);
  }

  protected override extractUndoState(state: VideoContentState): UndoState2D {
    return { viewBox: state.viewBox };
  }
}
